import { CHECKPOINT_APPS, type CheckpointAppName } from '../checkpoint/app-names';

export const SETTINGS_APP_NAME: CheckpointAppName = CHECKPOINT_APPS.GRAPH_EDITOR;
